$(function () {
	const DUR = 400;
	const PROG = 20000;

	// ===== helpers =====
	function openItem($acc, $item){
		const $titles   = $acc.find(".accordion__title");
		const $contents = $acc.find(".accordion__content");

		if ($acc.hasClass('accordion-auto')) stopProgress($acc);

		$contents.not($item.children(".accordion__content"))
			.stop(true, false).slideUp(DUR);
		$titles.not($item.children(".accordion__title"))
			.removeClass("accordion-active")
			.find(".accordion__arrow").removeClass("accordion__rotate");

		const $title = $item.children(".accordion__title");
		const $content = $item.children(".accordion__content");

		$title.addClass("accordion-active")
			.find(".accordion__arrow").addClass("accordion__rotate");
		$content.stop(true, false).slideDown(DUR);

		if ($acc.hasClass('accordion-auto')) startProgress($acc, $item);
	}

	function nextItem($acc, $fromItem){
		const $items = $acc.find(".accordion__item");
		const i = $items.index($fromItem);
		const $next = (i >= 0 && i < $items.length - 1) ? $items.eq(i + 1) : $items.eq(0);
		openItem($acc, $next);
	}

	function stopProgress($acc){
		const token = (Number($acc.data('progToken')) || 0) + 1;
		$acc.data('progToken', token);

		$acc.find('.accordion__progress')
			.stop(true, false)
			.hide()
			.css({ width: '0%' });
	}

	function startProgress($acc, $item){
		const myToken = (Number($acc.data('progToken')) || 0) + 1;
		$acc.data('progToken', myToken);

		$acc.find('.accordion__item').not($item).each(function(){
			$(this).find('.accordion__progress')
				.stop(true, false).hide().css({ width: '0%' });
		});

		const $bar = $item.find('.accordion__progress');
		if (!$bar.length) return;

		$bar.stop(true, false)
			.show()
			.css({ width: '0%' })
			.animate({ width: '100%' }, PROG, 'linear', function(){
				// перевіряємо актуальність токена і що саме цей item досі активний
				if (Number($acc.data('progToken')) !== myToken) return;

				const isStillActive = $item.children(".accordion__title").hasClass("accordion-active");
				if (!isStillActive) return;

				nextItem($acc, $item);
			});
	}

	$(".accordion").on("click", ".accordion__title", function(e) {
		e.preventDefault();
		const $title = $(this);
		const $acc   = $title.closest('.accordion');
		const $item  = $title.closest('.accordion__item');

		if ($title.hasClass("accordion-active")) return;

		openItem($acc, $item);
	});

	$(".accordion.accordion-auto").each(function () {
		const $acc = $(this);
		const $items = $acc.find(".accordion__item");

		const $active = $acc.find(".accordion__title.accordion-active").closest(".accordion__item");
		if ($active.length) {
			$items.each(function(){
				const $it = $(this);
				const isActive = $it.find(".accordion__title").hasClass("accordion-active");
				$it.find(".accordion__content")[isActive ? 'show' : 'hide']();
				$it.find(".accordion__arrow").toggleClass('accordion__rotate', isActive);
			});
			startProgress($acc, $active);
		} else if ($items.length) {
			const $first = $items.eq(0);
			$first.find(".accordion__title").addClass("accordion-active")
				.find(".accordion__arrow").addClass("accordion__rotate");
			$first.find(".accordion__content").show();
			startProgress($acc, $first);
		}
	});
});
